import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { invitationAPI } from '../services/api';
import api from '../services/api';
import './ClubFund.css';

function ClubInvite() {
  const { clubId } = useParams();
  const [invitations, setInvitations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('email');
  const [emails, setEmails] = useState('');
  const [phones, setPhones] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  // Invite link state
  const [inviteLink, setInviteLink] = useState(null);
  const [generatingLink, setGeneratingLink] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);

  useEffect(() => { loadInvites(); }, [clubId]);

  const loadInvites = async () => {
    setLoading(true);
    try {
      const data = await invitationAPI.list(clubId);
      setInvitations(data.invitations || []);
    } catch (err) { /* ignore */ }
    setLoading(false);
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);
    const emailList = emails.split(/[,\n]/).map(e => e.trim()).filter(Boolean);
    try {
      const data = await invitationAPI.send(clubId, emailList, message);
      setResult({ success: true, message: `Sent ${data.sent?.length || 0} email invitation(s)` });
      setEmails('');
      setMessage('');
      loadInvites();
    } catch (err) {
      setResult({ success: false, message: err.response?.data?.error || 'Failed to send' });
    }
    setSending(false);
  };

  const handleSendSms = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);
    const phoneList = phones.split(/[,\n]/).map(p => p.trim()).filter(Boolean);
    try {
      const res = await api.post(`/api/club/${clubId}/invite-sms`, { phones: phoneList, message });
      setResult({ success: true, message: res.data.message });
      setPhones('');
      setMessage('');
    } catch (err) {
      setResult({ success: false, message: err.response?.data?.error || 'Failed to send SMS' });
    }
    setSending(false);
  };

  const handleGenerateLink = async () => {
    setGeneratingLink(true);
    setLinkCopied(false);
    try {
      const data = await invitationAPI.generateLink(clubId);
      if (data.success) {
        setInviteLink(data.url);
      }
    } catch (err) {
      setResult({ success: false, message: err.response?.data?.error || 'Failed to generate link' });
    }
    setGeneratingLink(false);
  };

  const handleCopyLink = async () => {
    if (!inviteLink) return;
    try {
      await navigator.clipboard.writeText(inviteLink);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch {
      // Fallback
      const input = document.createElement('input');
      input.value = inviteLink;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    }
  };

  const handleResend = async (inviteId) => {
    try {
      const data = await invitationAPI.resend(inviteId);
      setResult({ success: true, message: data.message });
    } catch (err) {
      setResult({ success: false, message: err.response?.data?.error || 'Failed to resend' });
    }
  };

  const tabs = ['email', 'sms', 'link'];

  return (
    <div>
      <h2>Invite Your Mates</h2>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {tabs.map(tab => (
          <button key={tab} onClick={() => { setActiveTab(tab); setResult(null); }} className={`history-tab ${activeTab === tab ? 'active' : ''}`} style={{
            padding: '8px 20px', border: 'none', borderRadius: 6, cursor: 'pointer',
            background: activeTab === tab ? '#fbbf24' : 'rgba(0,0,0,0.25)', color: activeTab === tab ? '#000' : '#aaa',
            fontWeight: 600, textTransform: 'uppercase', fontSize: 12
          }}>{tab === 'email' ? 'Email' : tab === 'sms' ? 'SMS' : 'Link'}</button>
        ))}
      </div>

      {activeTab === 'email' && (
        <form onSubmit={handleSendEmail} className="fund-form">
          <div className="form-group">
            <label>Email Addresses (one per line or comma-separated)</label>
            <textarea value={emails} onChange={(e) => setEmails(e.target.value)}
              placeholder={"mate1@email.com\nmate2@email.com"} rows={4} required
              className="dark-input" style={{ width: '100%', background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#fff', padding: '0.75rem', resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box' }} />
          </div>
          <div className="form-group">
            <label>Personal Message (optional)</label>
            <input type="text" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Come join our club!"
              className="dark-input" style={{ width: '100%', background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#fff', padding: '0.75rem', boxSizing: 'border-box' }} />
          </div>
          {result && <div className={`result-message ${result.success ? 'success' : 'error'}`}>{result.message}</div>}
          <button type="submit" className="btn-submit" disabled={sending || !emails.trim()}>
            {sending ? 'Sending...' : 'Send Email Invitations'}
          </button>
        </form>
      )}

      {activeTab === 'sms' && (
        <form onSubmit={handleSendSms} className="fund-form">
          <div className="form-group">
            <label>Phone Numbers (one per line or comma-separated)</label>
            <textarea value={phones} onChange={(e) => setPhones(e.target.value)}
              placeholder={"0400123456\n0412345678"} rows={4} required
              className="dark-input" style={{ width: '100%', background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#fff', padding: '0.75rem', resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box' }} />
          </div>
          <div className="form-group">
            <label>Personal Message (optional)</label>
            <input type="text" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Come join our club!"
              className="dark-input" style={{ width: '100%', background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#fff', padding: '0.75rem', boxSizing: 'border-box' }} />
          </div>
          {result && <div className={`result-message ${result.success ? 'success' : 'error'}`}>{result.message}</div>}
          <button type="submit" className="btn-submit" disabled={sending || !phones.trim()}>
            {sending ? 'Sending...' : 'Send SMS Invitations'}
          </button>
        </form>
      )}

      {activeTab === 'link' && (
        <div className="fund-form">
          <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>Shareable Invite Link</h3>
          <p style={{ color: '#999', fontSize: '0.85rem', marginBottom: '1rem' }}>
            Generate a link you can share via text, social media, or anywhere else. Anyone with the link can join your club.
          </p>

          {inviteLink ? (
            <div>
              <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem' }}>
                <input type="text" readOnly value={inviteLink} style={{ flex: 1, background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#fff', padding: '0.75rem', fontSize: '0.85rem', boxSizing: 'border-box' }} />
                <button onClick={handleCopyLink} style={{ background: linkCopied ? '#10b981' : '#fbbf24', color: linkCopied ? '#fff' : '#000', border: 'none', borderRadius: '8px', padding: '0 1.25rem', cursor: 'pointer', fontWeight: 600, whiteSpace: 'nowrap' }}>
                  {linkCopied ? 'Copied!' : 'Copy'}
                </button>
              </div>
              <button onClick={handleGenerateLink} style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#999', borderRadius: '8px', padding: '0.6rem', cursor: 'pointer', fontSize: '0.85rem' }}>
                Generate New Link
              </button>
            </div>
          ) : (
            <button onClick={handleGenerateLink} className="btn-submit" disabled={generatingLink}>
              {generatingLink ? 'Generating...' : 'Generate Invite Link'}
            </button>
          )}
          {result && <div className={`result-message ${result.success ? 'success' : 'error'}`} style={{ marginTop: '0.75rem' }}>{result.message}</div>}
        </div>
      )}

      {/* Sent Invitations */}
      <div className="recent-transactions">
        <h3>Sent Invitations</h3>
        {loading ? <p style={{ color: '#666' }}>Loading...</p> :
          invitations.length === 0 ? <p className="no-transactions">No invitations sent yet</p> :
          invitations.map((inv) => (
            <div key={inv.id} className="transaction-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="tx-info">
                <span className="tx-description">{inv.email || '(link invite)'}</span>
                <span className="tx-date">{new Date(inv.created).toLocaleDateString()}</span>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                <span style={{ color: inv.status === 'accepted' ? '#10b981' : inv.status === 'pending' ? '#fbbf24' : '#999', fontSize: '0.8rem', fontWeight: 600, textTransform: 'uppercase' }}>{inv.status}</span>
                {inv.status === 'pending' && inv.email && (
                  <button onClick={() => handleResend(inv.id)} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', color: '#999', borderRadius: '4px', padding: '2px 8px', cursor: 'pointer', fontSize: '0.7rem' }}>
                    Resend
                  </button>
                )}
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default ClubInvite;
